/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Who3_LinkInputs */

const en_dr_who3_link = /** @type {(inputs: Dr_Who3_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See Bystep Campus`)
};

const id_dr_who3_link = /** @type {(inputs: Dr_Who3_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Bystep Campus`)
};

/**
* | output |
* | --- |
* | "See Bystep Campus" |
*
* @param {Dr_Who3_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_who3_link = /** @type {((inputs?: Dr_Who3_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Who3_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_who3_link(inputs)
	return en_dr_who3_link(inputs)
});